import api from "../../../services/api";

export async function search(text, term) {
  const result = await api.get(`pasta/search/?pesq=${text}&term=${term}`);

  return result.data.results;
}



// WEBPACK FOOTER //
// ./src/components/Search/v2/search-service.js